import React from 'react';
import {useDispatch} from 'react-redux';
import {clearNotFoundEmails} from '../../redux/dialogue/actions';

export const NotFoundEmailCard: React.FC<{emails: string[]}> = ({emails}) => {
  const dispatch = useDispatch();

  const handleClose = () => dispatch(clearNotFoundEmails());

  if (!emails?.length) return null;

  return (
    <div className="not-found-email" role="alert" aria-live="polite">
      <button
        type="button"
        className="not-found-email__btn"
        onClick={handleClose}
        aria-label="Close"
      >
        ×
      </button>

      <div className="not-found-email__content">
        <div className="not-found-email__title">Users not found</div>
        <div className="not-found-email__subtitle">
          We couldn’t find users for the following email{emails.length > 1 ? 's' : ''}:
        </div>

        <ul className="not-found-email__list">
          {emails.map((e) => (
            <li key={e} className="not-found-email__item">
              {e}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
